import React, { useEffect, useState } from "react";
import { stageAssignmentsAPI } from "../../api/client";

export default function EligibleUserSelect({
  projectId,
  stageId,
  value,
  onChange,
  disabled = false,
}) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!projectId || !stageId) {
      setUsers([]);
      return;
    }
    const load = async () => {
      try {
        setLoading(true);
        setError("");
        const resp = await stageAssignmentsAPI.eligibleUsers(
          projectId,
          stageId,
        );
        setUsers(resp.data || []);
      } catch (err) {
        setError(
          err.response?.data?.message || "Failed to load eligible users",
        );
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [projectId, stageId]);

  const getAssignedProjectCount = (user) => {
    const items = Array.isArray(user.stageAssigneeItems)
      ? user.stageAssigneeItems
      : [];
    const projectIds = new Set(items.map((item) => item.project?.id).filter(Boolean));
    return projectIds.size;
  };

  return (
    <div>
      <select
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled || loading || !stageId}
      >
        <option value="">Select eligible user...</option>
        {users
          .filter(
            (u) =>
              !u.isAdmin &&
              !(u.roles || []).some((role) => role.name === "Admin"),
          )
          .map((user) => (
            <option key={user.id} value={user.id}>
              {user.firstName} {user.lastName}
              {user.roles?.length
                ? ` (${user.roles.map((role) => role.name).join(", ")})`
                : user.role?.name
                  ? ` (${user.role.name})`
                  : ""}
              {` · Assigned: ${getAssignedProjectCount(user)}`}
            </option>
          ))}
      </select>
      {loading && <div className="small-muted">Loading eligible users...</div>}
      {error && (
        <div className="small-muted" style={{ color: "#b91c1c" }}>
          {error}
        </div>
      )}
    </div>
  );
}
